<template>
    <div>
        <b-modal
            id="add-webhook-popup"
            ref="modal"
            :title="title"
            :hide-header-close="loading"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Title"
                            label-for="app-title"
                        >
                            <b-form-input
                                id="app-title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    max: 50,
                                    min: 6,
                                }"
                                type="text"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter title"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Endpoint URL"
                            label-for="app-url"
                        >
                            <b-form-input
                                id="app-url"
                                v-model="formData.endpointUrl"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="endpointUrl"
                                :class="{
                                    'is-invalid': errors.has('endpointUrl'),
                                }"
                                autocomplete="no"
                                placeholder="Enter URL"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Description"
                            label-for="app-desc"
                        >
                            <b-form-textarea
                                id="app-desc"
                                v-model="formData.description"
                                v-validate="{ required: false, max: 500 }"
                                rows="3"
                                placeholder="Please provide a detailed description (optional)"
                                data-vv-name="description"
                                :class="{
                                    'is-invalid': errors.has('description'),
                                }"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import resource from '@/api/resource'

const webhooks = new resource('access-control/webhooks')
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props
    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            selectedIds: [],
            formData: this.initializeFormData(),
            options: [],
        }
    },
    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        title() {
            return this.selectedItem ? 'Modify Webhook' : 'Add Webhook'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            let self = this
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value._id
                this.selectedIds = []
                if (!this.formData.dataSegmentIds.length) {
                    self.selectedIds.push({
                        code: 'All',
                        id: 'all',
                    })
                } else {
                    this.formData.dataSegments.forEach(function (val) {
                        self.selectedIds.push({ code: val.code, id: val._id })
                    })
                }
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },

        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
        selectedIds(val) {
            let allSelected = _.find(val, { id: 'all' })
            if (allSelected) {
                _.remove(val, function (n) {
                    return n.id != 'all'
                })
                this.options.forEach(function (ele) {
                    if (ele.id !== 'all') {
                        ele.$isDisabled = true
                    }
                })
            } else {
                this.options.forEach(function (ele) {
                    ele.$isDisabled = false
                })
            }
        },
    }, // End of Component > watch

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {},
    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        //initialize form data
        initializeFormData() {
            return {
                id: '',
                title: '',
                endpointUrl: '',
                description: '',
                dataSegmentId: localStorage.getItem('dataSegmentId'),
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    this.$store.commit('setLoading', true)
                    let data = []
                    if (this.formData.id) {
                        delete this.formData.dataSegmentCodes
                        delete this.formData.dataSegments
                        delete this.formData.status
                        data = await webhooks.update(
                            this.formData._id,
                            this.formData
                        )
                    } else {
                        console.log('im creating webhook')
                        data = await webhooks.store(this.formData)
                    }
                    data = data.data

                    if (data) {
                        this.$store.commit('setSuccess', data.message)
                    }
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$store.commit('clearItem')
            this.selectedIds = []
            this.$store.commit('setLoading', false)

            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        },
    },
}
</script>
